module.exports = __webpack_public_path__ + "img/icon_map_61_on_110.5fce50bc.png";